import { getResultColumns, resultGridMinWidth, resultGridTemplate } from './result-columns';
import { PersonSearchSelect } from '~/pages/person/components/person-search-select';
import { useAuthentication } from '~/hooks/useAuthentication';
import { usePersonQuery } from '~/pages/person/queries';
import { ResultGridFrame } from './result-grid';
import { ResultRow } from './result-row';
import { Grid } from '~/components/Grid/Grid';
import { useState } from 'react';

interface Props {
  competitionId: number;
  isTeamComp: boolean;
  competitionStartDate?: string;
  disabled?: boolean;
}

/**
 * Adds a licensed lifter who isn't among the competition's registrations. The picked lifter gets the
 * same inline grid row as the registered lifters, so both result-entry paths look and behave alike.
 */
export function AddLicensedLifter({ competitionId, isTeamComp, competitionStartDate, disabled }: Props) {
  const { isSuperUser } = useAuthentication();
  const [lifter, setLifter] = useState<[string, number] | undefined>();
  const { data: person } = usePersonQuery(lifter?.[1]);

  const columns = getResultColumns({ isTeamComp, isSuperUser });
  const template = resultGridTemplate(columns);
  const minWidth = resultGridMinWidth(columns);

  return (
    <>
      <Grid>
        <Grid.Item cols={{ lg: 4, sm: 12 }}>
          <PersonSearchSelect
            onChange={([name, personId]) => setLifter([name, Number(personId)])}
            query={{ valid_license_on: competitionStartDate ?? undefined }}
            placeholder="Sök efter licensierad lyftare..."
            value={lifter}
            disabled={disabled}
            name="person_id"
          />
        </Grid.Item>
      </Grid>

      {lifter && (
        <div style={{ marginTop: 'var(--size-4)' }}>
          <ResultGridFrame columns={columns} template={template} minWidth={minWidth} showHeader={false}>
            <ResultRow
              labeled
              lifterId={lifter[1]}
              name={person ? `${person.first_name} ${person.last_name}` : lifter[0]}
              meta={person ? `${person.license_id} · ${person.club.name}` : undefined}
              competitionId={competitionId}
              isTeamComp={isTeamComp}
              columns={columns}
              template={template}
              onFinish={() => setLifter(undefined)}
            />
          </ResultGridFrame>
        </div>
      )}
    </>
  );
}
